import { z } from "zod";
export { default as link } from "./assets/link.svg";
export { default as media } from "./assets/media.svg";
export { default as mediaSquare } from "./assets/media-square.svg";
export { default as playerSquare } from "./assets/player-square.svg";
export { default as linkSquare } from "./assets/link-square.svg";
export { default as download } from "./assets/download.svg";
export { default as downloadSquare } from "./assets/download-square.svg";
export { default as accordionPlus } from "./assets/accordion-plus.svg";
export { default as accordionMinus } from "./assets/accordion-minus.svg";
export { default as arrowRight } from "./assets/arrow-right.svg";
export { default as arrowLeft } from "./assets/arrow-left.svg";
export { default as dropdown } from "./assets/dropdown.svg";
export { default as search } from "./assets/search.svg";
export { default as player } from "./assets/player.svg";
export { default as close } from "./assets/close.svg";
export { default as platformWindows } from "./assets/platform-windows.svg";
export { default as platformMac } from "./assets/platform-mac.svg";
export { default as platformIos } from "./assets/platform-ios.svg";
export { default as platformAndroid } from "./assets/platform-android.svg";
export { default as platformPC } from "./assets/platform-pc.svg";
export { default as platformPSN } from "./assets/platform-psn.svg";
export { default as platformXbox } from "./assets/platform-xbox.svg";
export { default as rhombus } from "./assets/rhombus.svg";
export { default as volumeUp } from "./assets/volume-up.svg";
export { default as volumeDown } from "./assets/volume-down.svg";
export { default as pause } from "./assets/pause.svg";
export { default as play } from "./assets/play.svg";
export { default as linkUrl } from "./assets/link-url.svg";
export { default as checkmark } from "./assets/checkmark.svg";
export { default as playstation } from "./assets/playstation.svg";
export { default as xbox } from "./assets/xbox.svg";
export { default as plus } from "./assets/plus.svg";
export { default as marqueeArrowRight } from "./assets/marqueeArrowRight.svg";
export { default as divider } from "./assets/divider.svg";
export { default as square } from "./assets/square.svg";
export { default as discord } from "./assets/discord.svg";
export { default as facebook } from "./assets/facebook.svg";
export { default as instagram } from "./assets/instagram.svg";
export { default as share } from "./assets/share.svg";
export { default as twitch } from "./assets/twitch.svg";
export { default as vk } from "./assets/vk.svg";
export { default as youtube } from "./assets/youtube.svg";
export { default as line } from "./assets/line.svg";
export { default as x } from "./assets/x.svg";
export { default as reddit } from "./assets/reddit.svg";
export { default as roleAssassin } from "./assets/roleAssassin.svg";
export { default as roleFighter } from "./assets/roleFighter.svg";
export { default as roleMage } from "./assets/roleMage.svg";
export { default as roleMarksman } from "./assets/roleMarksman.svg";
export { default as roleSupport } from "./assets/roleSupport.svg";
export { default as roleTank } from "./assets/roleTank.svg";
export { default as roleController } from "./assets/roleController.svg";
export { default as roleDuelist } from "./assets/roleDuelist.svg";
export { default as roleInitiator } from "./assets/roleInitiator.svg";
export { default as roleSentinel } from "./assets/roleSentinel.svg";
export { default as difficultyLow } from "./assets/difficultyLow.svg";
export { default as difficultyMed } from "./assets/difficultyMed.svg";
export { default as difficultyHigh } from "./assets/difficultyHigh.svg";
export const carouselLeft = "";
export const carouselRight = "";
export const IconTypesSchema = z.union([
    z.literal("link"),
    z.literal("media"),
    z.literal("mediaSquare"),
    z.literal("playerSquare"),
    z.literal("linkSquare"),
    z.literal("accordionPlus"),
    z.literal("accordionMinus"),
    z.literal("arrowRight"),
    z.literal("arrowLeft"),
    z.literal("dropdown"),
    z.literal("search"),
    z.literal("player"),
    z.literal("close"),
    z.literal("platformWindows"),
    z.literal("platformMac"),
    z.literal("platformIos"),
    z.literal("platformAndroid"),
    z.literal("platformPC"),
    z.literal("platformPSN"),
    z.literal("platformXbox"),
    z.literal("carouselLeft"),
    z.literal("carouselRight"),
    z.literal("discord"),
    z.literal("facebook"),
    z.literal("instagram"),
    z.literal("share"),
    z.literal("twitch"),
    z.literal("vk"),
    z.literal("youtube"),
    z.literal("line"),
    z.literal("x"),
    z.literal("reddit"),
    z.literal("rhombus"),
    z.literal("volumeUp"),
    z.literal("volumeDown"),
    z.literal("pause"),
    z.literal("play"),
    z.literal("linkUrl"),
    z.literal("checkmark"),
    z.literal("playstation"),
    z.literal("xbox"),
    z.literal("roleAssassin"),
    z.literal("roleFighter"),
    z.literal("roleMage"),
    z.literal("roleMarksman"),
    z.literal("roleSupport"),
    z.literal("roleTank"),
    z.literal("roleController"),
    z.literal("roleDuelist"),
    z.literal("roleSentinel"),
    z.literal("roleInitiator"),
    z.literal("difficultyLow"),
    z.literal("difficultyMed"),
    z.literal("difficultyHigh"),
    z.literal("plus"),
    z.literal("download"),
    z.literal("downloadSquare"),
    z.literal("marqueeArrowRight"),
    z.literal("divider"),
    z.literal("square"),
]);
//# sourceMappingURL=icons.js.map